/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `Dynamic` - Dynamic
 * * `RiskAssessment` - RiskAssessment
 * * `LinkedObject` - LinkedObject
 * * `Comment` - Comment
 */
export enum FormTypeEnum {
    DYNAMIC = 'Dynamic',
    RISK_ASSESSMENT = 'RiskAssessment',
    LINKED_OBJECT = 'LinkedObject',
    COMMENT = 'Comment',
}
